import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import {Kit} from './kit';
import {ElementService} from './element.service';
import {DataStoreService} from './data-store.service';
import {Folder, IRawFolder, mapFolder} from './folder';
import {Element, mapElement} from './element';
import {Subject} from 'rxjs/Subject';
import {extractData} from './utils';
import {Field, IRawField, mapField} from './field';
import {onlyKitLevelFields} from './global-constants.service';

@Injectable()
export class KitService extends DataStoreService<Kit> {

  kitLoaded$ = new Subject<boolean>();

  constructor(
    private http: Http,
    private elementService: ElementService
  ) {
    super();
    this.elementService.inserts$().subscribe((el) => this.addElementToKit(el));
    this.elementService.deletes$().subscribe((el) => this.deleteElementFromKit(el));
  }

  static mapKit(object: any): Kit {
    return new Kit(
      object.id,
      object.name,
      object.description,
      object.thumbnail,
      object.thumbnail_relative,
      object.video_preview,
      object.video_preview_relative,
      object.banner,
      object.banner_relative,
      object.ord,
      +object.public,
      +object.featured,
      object.style_id,
      object.resolution_id,
      object.frame_rate_id,
      object.code,
      object.elements ? object.elements.map((element) => mapElement(Object.assign(element, {kit_id: object.id}))) : [],
      object.style,
      object.resolution,
      object.frame_rate,
      object.fields ? onlyKitLevelFields(removeCertainFields(object.fields.map((rawField: IRawField) => mapField(rawField)))) : [],
      object.groups ? object.groups : [],
      object.folders ? object.folders.map((rawFolder: IRawFolder) => mapFolder(Object.assign(rawFolder, {kit_id: object.id}))) : [],
      object.updated_at,
      object.created_at);
  }

  getAll() {
    return this.http.get(`${environment.apiUrl}/admin/kits`)
      .map(extractData)
      .do(
        (data) => {
          if (data instanceof Array) {
            data.forEach((rawKit) => {

              let kit = KitService.mapKit(rawKit);
              this.insert(kit.id, kit);
            });
          }
        });
  }

  insert(id: number, kit: Kit) {

    kit.elements.forEach((element) => {
      this.elementService.insert(element.id, element);
    });

    super.insert(id, kit);
  }

  createNew(kit) {

    return this.http
      .post(`${environment.apiUrl}/admin/kits`, kit)
      .map(extractData)
      .do((kit) => this.insert(kit.id, KitService.mapKit(kit)))
      .catch(this.handleError);
  }

  addFolderToKit(kit: Kit, folder: Folder) {
    super.update(kit, {folders: kit.folders.concat(folder)});
  }


  update(kit) {
    return this.http
      .put(`${environment.apiUrl}/admin/kits/${kit.id}`, kit)
      .map(extractData)
      .map((rawKit: any) => KitService.mapKit(rawKit))
      .map((mappedKit: any) => {

        super.update(this.find(mappedKit.id), mappedKit);

        return this.find(mappedKit.id);
      });
  }

  updateOrder(kits) {
    let order = [];

    kits.forEach((kit, index) => {
      order.push({id: kit.id, ord: index});
    });

    return this.http
      .post(
        `${environment.apiUrl}/admin/kits/order/update`,
        {kits: JSON.stringify(order)}
      ).map(extractData);
  }

  private deleteElementFromKit(el) {
    if (el.kit_id) {
      let kit = this.find(el.kit_id);
      if (kit) {
        let index = kit.elements.indexOf(el);
        if (index !== -1) {
          kit.elements.splice(index, 1);
        }
      }
    }
  }

  private addElementToKit(el) {
    if (el.kit_id) {
      let kit = this.find(el.kit_id);
      if (kit) {

        kit.elements.push(el);
        kit.rootLevelElements = kit.elements.filter((element: Element) => element.folder_id === null);
        super.update(kit, {});
      }
    }
  }


  private handleError (error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}

export const UNWANTED_KIT_FIELDS = ['rendermodule'];

export function removeCertainFields(fields: Field[]) {

  return fields.filter((field: Field) => {
    if (UNWANTED_KIT_FIELDS.indexOf(field.label.toLowerCase()) >= 0) {
      return false;
    }
    return true;
  })
}


// WEBPACK FOOTER //
// ./src/app/services/kit.service.ts